// extracted by mini-css-extract-plugin
export default {"container":"BaseContent_container__g5USP"};